const __filename = "/app/components/cms/blocks/reviews_carousel/ns.js", __dirname = "/app/components/cms/blocks/reviews_carousel";
import WebComponent from '@rubygems/hue/app/components/web_component'

// The reviews.io carousel — see ns.rb for why this block ships JavaScript at all, and for what of
// live's own loader is deliberately not carried over.
//
// The vendor's script defines a global `carouselInlineWidget` constructor and nothing else; there
// is no markup-only mode, so the widget cannot exist until this runs. Everything it needs comes
// off the element's `data-config`, which ns.rb wrote — no configuration is duplicated here.
WebComponent.register(
  class extends WebComponent {
    // Named to match `extend Hue::Phlex::CustomElement(:reviews_carousel)` rather than derived
    // from this filename: the file is `ns.js`, and `buildName` would make it
    // `components-cms-blocks-reviews-carousel-ns`.
    static componentName = 'reviews-carousel'

    // `?_t=2023032006` is live's own pin, on this script and on both stylesheets — carried so this
    // page draws the widget build the page it replaces draws, rather than whatever the vendor
    // happens to ship today.
    static scriptUrl =
      'https://widget.reviews.co.uk/carousel-inline-iframeless/dist.js?_t=2023032006'

    // One promise for the whole document. The block can appear once per page today, but a page
    // carrying two would otherwise load the vendor's 100KB bundle twice.
    static loading = null

    connectedCallback() {
      super.connectedCallback()
      this.draw()
    }

    async draw() {
      const target = this.querySelector('[data-role="widget"]')
      if (!target) return

      let config
      try {
        config = JSON.parse(this.dataset.config)
      } catch {
        // A malformed config is a bug in the block, not something a reader should see a broken
        // widget for — leave the fallback text in place.
        return
      }

      // The element needs an id of its own: the vendor's constructor takes one rather than a node.
      if (!target.id) target.id = `reviewsio-carousel-${crypto.randomUUID()}`

      try {
        await this.constructor.load()
      } catch {
        return
      }

      if (typeof carouselInlineWidget !== 'function') return

      new carouselInlineWidget(target.id, config)
    }

    static load() {
      this.loading ||= new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = this.scriptUrl
        script.async = true
        script.addEventListener('load', resolve, { once: true })
        script.addEventListener('error', reject, { once: true })
        document.head.append(script)
      })

      return this.loading
    }
  }
)
